import { FC } from "react";
import { HiOutlinePencilSquare, HiOutlinePlus } from "react-icons/hi2";
import { Tag, TagProps } from "./Tag";

export type TagActionButtonProps = Omit<TagProps, "children"> & {
	showManage?: boolean;
	onClick: () => void;
};

export const TagActionButton: FC<TagActionButtonProps> = ({
	iconOnly,
	showManage,
	onClick,
}: TagActionButtonProps) => (
	<Tag
		iconOnly={iconOnly}
		onClick={(e) => {
			e.preventDefault();
			onClick();
		}}
	>
		{showManage ? (
			<>
				<HiOutlinePencilSquare className={`stroke-[2.5px] ${iconOnly ? "text-[11px]" : "mr-2"}`} />
				{!iconOnly && <span className="font-medium max-h-6">Manage Tags</span>}
			</>
		) : (
			<>
				<HiOutlinePlus className={`stroke-[2.5px] ${iconOnly ? "text-[11px]" : "mr-2"}`} />
				{!iconOnly && <span className="font-medium max-h-6">Add Tags</span>}
			</>
		)}
	</Tag>
);
